module.exports = __webpack_public_path__ + "static/media/Dyal SIngh Building c. 1959.5c474110.jpg";